import React from "react";
import { Colors } from "@constants";
import { I18n } from "react-redux-i18n";

interface IProps {
  backgroundColor?: string;
  color?: string;
  size?: string;
}

export const InformationSquare: React.FC<IProps> = ({
  backgroundColor = Colors.black,
  size = "22",
  color = Colors.white,
}) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 22 22"
      width={size}
      height={size}
    >
      <title>{I18n.t("hoverIcons.important")}</title>
      <path
        id="background"
        fill={backgroundColor}
        d="M 2.7500002,0 H 19.25 C 20.7735,0 22,1.2265001 22,2.7500002 V 19.250002 c 0,1.5235 -1.2265,2.75 -2.75,2.75 H 2.7500002 C 1.2265001,22.000002 0,20.773502 0,19.250002 V 2.7500002 C 0,1.2265001 1.2265001,0 2.7500002,0 Z" />
      <path id="letter" fill={color} d="M 9.7073842,4.8785399 V 7.3178516 H 12.146612 V 4.8785399 Z m 0,4.8786237 V 17.075015 H 12.146612 V 9.7571636 Z"
      />
   </svg>
)}
